import { SetLoader } from '../../redux/actions/loader'
import { store } from '../../redux/store'
import { DELETE, GET, POST, PUT } from '../API'
const { dispatch } = store

export {
  ASSET_STATUS_ENUM,
  DeleteCustomer,
  GetAllCustomers,
  GetCustomerInfo,
  GetDeviceHierarchy,
  GetPaginationCustomersList,
  GetPaginationCustomersListWithSearch,
  GetSFDCustomerTemplate,
  GetUserCustomers,
  addHierarchy,
  changeCustomerStatus,
  getCustomerSettings,
  getHierarchy,
  getRegions,
  saveCustomer,
  setBatchDynamicAlarm as sendCommandToCustomerDevices,
  setBatchDynamicAlarm,
  updateCustomerSettings,
  updateDynamicAlertSettings,
  updateStaticAlertSettings,
}

const ASSET_STATUS_ENUM = {
  REGISTERED: 'REGISTERED',
  CONFIGURED: 'CONFIGURED',
  PROVISIONED: 'PROVISIONED',
  ACTIVE: 'ACTIVE',
  ALL: 'ALL',
}
// localhost:9999/spectro/customers/search?product=cold&title=sh&page=0&size=10&status=Active
const GetPaginationCustomersListWithSearch = async (
  userEmail,
  productName,
  title,
  currentPage,
  size,
  status,
) => {
  const queryParams = {
    product: productName,
    title,
    page: currentPage,
    size,
    status,
  }
  // dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/customers/search/${userEmail}`,
    queryParams,
  )
  // dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }

  return []
}
// localhost:9999/spectro/customers/aa@spectro.net?product=cold&page=0&size=5
const GetPaginationCustomersList = async (
  userEmail,
  productName,
  currentPage,
  size,
) => {
  const queryParams = {
    product: productName,
    page: currentPage,
    size,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/customers/${userEmail}`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const GetAllCustomers = async (userEmail, productName) => {
  const queryParams = {
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/customers/${userEmail}`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

// to get SFDA customer template config
// localhost:9999/spectro/customers/templates/SFDA?product=cold
const GetSFDCustomerTemplate = async (customerType, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const response = await GET(
    `/spectro/customers/templates/${customerType}/`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}
// localhost:9999/spectro/customers/aa@spectro.net?product=cold
// get user customers
const GetUserCustomers = async (userEmail, productName) => {
  const queryParams = {
    product: productName,
  }

  dispatch(SetLoader(true))
  const response = await GET(`/spectro/customers/${userEmail}`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}
// http://localhost:9999/spectro/users/{user title}?product=cold

const DeleteCustomer = async (customerTile, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&')
  const response = await DELETE(`/spectro/users/${customerTile}`, queryString)
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  return {}
}

// localhost:9999/spectro/customers/aa@spectro.net/SH_Co2
const GetCustomerInfo = async (userEmail, title, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const response = await GET(
    `/spectro/customers/${userEmail}/${title}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

// http://localhost:9999/spectro/users/register/aa@spectro.net?product=cold

const saveCustomer = async (productName, email, bodyData, customerType) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const body = {
    type: customerType,
    'first name': bodyData.firstName,
    'last name': bodyData.lastName,
    title: bodyData.title,
    description: bodyData.description,
    country: bodyData.country,
    city: bodyData.city,
    state: bodyData.state,
    'zip code': bodyData['Zip Code'],
    address: bodyData.address,
    address2: bodyData.address2,
    suddenDropAlarmsThreshold: bodyData.suddenDropAlarmsThreshold,
    phone: bodyData.phone,
    email: bodyData.email,
    'sfda-common': {
      'sfda identity number': bodyData.identityNumber,
      'sfda phone number': bodyData.phoneNumber,
      'sfda extension number': bodyData.extensionNumber,
      'sfda email address': bodyData.emailAddress,
      'sfda company activity': bodyData.sfdaCompanyActivity,
    },
    'sfda-company': {
      'sfda commercial record number': bodyData.commercialRecordNumber,
      'sfda commercial record issue date hijri':
        bodyData.commercialRecordIssueDateHijri,
      'sfda manager name': bodyData.managerName,
      'sfda manager phone number': bodyData.managerPhoneNumber,
      'sfda manager mobile number': bodyData.managerMobileNumber,
    },
    'sfda-individual': {
      'sfda date of birth hijri': bodyData.dateOfBirthHijri,
      'sfda date of birth gregorian': bodyData.DateOfbirthgregorian,
    },
  }
  // http://localhost:9999/spectro/customers/register/aa@spectro.net?product=cold
  const response = await POST(
    `/spectro/customers/register/${email}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  return response
}
// http://localhost:9999/spectro/customers/SH_Co2/change-status?product=cold&status=Inactive
const changeCustomerStatus = async (productName, title, customerId) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
    customerId,
  }

  const response = await PUT(
    `/spectro/customers/${title}/change-status`,
    queryParams,
  )
  dispatch(SetLoader(false))
  return response
}

const updateStaticAlertSettings = async (customerId, body) => {
  const queryParams = {}
  const response = await POST(
    `/spectro/customers/setStaticAlertSettings/${customerId}`,
    queryParams,
    body,
  )
  return response
}

const updateDynamicAlertSettings = async (deviceId, body) => {
  const queryParams = {}
  const response = await POST(
    `/spectro/customers/setDynamicAlertSettings/${deviceId}`,
    queryParams,
    body,
  )
  return response
}

const updateCustomerSettings = async (queryParams, body) => {
  const response = await PUT('/spectro/customers/settings', queryParams, body)
  return response
}

const getCustomerSettings = async (queryParams) => {
  const response = await GET('/spectro/customers/settings', queryParams)
  return response
}

const addHierarchy = async (queryParams, body) => {
  const response = await POST('/spectro/assets/hierarchy', queryParams, body)
  return response
}

const getHierarchy = async (queryParams) => {
  const response = await GET('/spectro/assets/hierarchy', queryParams)
  return response
}

const GetDeviceHierarchy = async (deviceId) => {
  const res = await GET(`/spectro/assets/hierarchy/device/${deviceId}`)
  return res
}

const getRegions = async (queryParams, zoneId) => {
  const response = await GET(`/spectro/assets/hierarchy/${zoneId}`, queryParams)
  return response
}

const setBatchDynamicAlarm = async (body) =>
  POST('/spectro/customers/devices/heightThreshold', {}, body)

const setSuddenDropAlarmsThreshold = async (body) => {
  const response = await POST(
    '/spectro/customers/devices/suddenDropAlarmsThreshold',
    {},
    body,
  )
  return response
}
const getSuddenDropAlarmsThreshold = async (customerId) => {
  const response = await GET(
    `/spectro/customers/devices/suddenDropAlarmsThreshold?customerId=${customerId}`,
  )
  return response
}
export { setSuddenDropAlarmsThreshold, getSuddenDropAlarmsThreshold }
